// based on rc-tooltip 3.7.3
import Tooltip from './Tooltip';

export default Tooltip;


//////////////////
// WEBPACK FOOTER
// ./~/ant-design-vue/es/vc-tooltip/index.js
// module id = 897
// module chunks = 0